<template>
    <div class="detail-data">
      <div class="detail-data-line">
        <div>Terminal:</div> <div class="gray">{{order_data.terminal}}</div>
      </div>
      <div class="detail-data-line">
        <div>Horario Terminal:</div> <div class="gray">{{order_data.dateTimeTerminal}}</div>
      </div>
      <div class="detail-data-line">
        <div>Cargador:</div> <div class="gray">{{order_data.cargador}}</div>
      </div>
      <div class="detail-data-line">
        <div>Horario Cargador:</div> <div class="gray">{{order_data.dateTimeCargador}}</div>
      </div>
      <div class="detail-data-line">
        <div>Número de contenedores:</div> <div class="gray">{{order_data.containerAmount}}</div>
      </div>
      <div class="detail-data-line">
        <div>Tamaño de contenedores:</div> <div class="gray">{{order_data.containerSize}}</div>
      </div>

    </div>
</template>

<script>
export default {
  name: 'OrderDetail',
  data(){
    return {
      order_data: {
        terminal: 'Puerto de Cartagena. Ter.3',
        dateTimeTerminal: '02-09-2020. De 08:00 a 09:30',
        cargador: 'Cargador 1',
        dateTimeCargador: '02-09-2020. De 10:00 a 12:00',
        containerAmount: '1',
        containerSize: '40 pies'
      }
    }
  },
  methods: {

  }
}
</script>

<style lang= "scss" scoped>
  .detail-data {
    margin: 0px 16px;
    padding-bottom: 20px;
    border-bottom: 2px solid #eeeeee;
  }
  .detail-data-line {
    display: flex;
    flex-direction: line;  
  }
  .gray {
    color: gray;
    padding-left: 5px;
  }
</style>
